import { i18n } from '@fs/zion-locale'

/**
 * Builds the pageDetail string for APAC pages.
 * Automatically prepends 'FamilySearch: asia-pacific: APAC:' and the page language.
 *
 * @param {string[]} pageDetails - Array of page detail parts in the order they should appear
 *
 * @returns {string} The formatted page detail string
 */
export function buildPageDetails(pageDetails) {
  if (!pageDetails || !Array.isArray(pageDetails) || pageDetails.length === 0) return ''

  return ['APAC', i18n.language, ...pageDetails].join(': ')
}
